import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { IoIosClose, IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const imageSections = {
  "Latest Highlights": [
    "/renamed_website_images/school-gallery-001.jpeg",
    "/renamed_website_images/school-gallery-002.jpeg",
    "/renamed_website_images/school-gallery-003.jpeg",
    "/renamed_website_images/school-gallery-004.jpeg",
    "/renamed_website_images/school-gallery-005.jpeg",
    "/renamed_website_images/school-gallery-006.jpeg",
    "/renamed_website_images/school-gallery-007.jpeg",
    "/renamed_website_images/school-gallery-008.jpeg",
    "/renamed_website_images/school-gallery-009.jpeg",
    "/renamed_website_images/school-gallery-010.jpeg",
    "/renamed_website_images/school-gallery-011.jpeg",
    "/renamed_website_images/school-gallery-012.jpeg",
    "/renamed_website_images/school-gallery-013.jpeg",
    "/renamed_website_images/school-gallery-014.jpeg",
    "/renamed_website_images/school-gallery-015.jpeg",
    "/renamed_website_images/school-gallery-016.jpeg",
    "/renamed_website_images/school-gallery-017.jpeg",
    "/renamed_website_images/school-gallery-018.jpeg",
    "/renamed_website_images/school-gallery-019.jpeg",
    "/renamed_website_images/school-gallery-020.jpeg",
    "/renamed_website_images/school-gallery-021.jpeg",
    "/renamed_website_images/school-gallery-022.jpeg",
    "/renamed_website_images/school-gallery-023.jpeg",
    "/renamed_website_images/school-gallery-024.jpeg",
    "/renamed_website_images/school-gallery-025.jpeg",
    "/renamed_website_images/school-gallery-026.jpeg",
    "/renamed_website_images/school-gallery-027.jpeg",
    "/renamed_website_images/school-gallery-028.jpeg",
    "/renamed_website_images/school-gallery-029.jpeg",
    "/renamed_website_images/school-gallery-030.jpeg",
    "/renamed_website_images/school-gallery-031.jpeg",
    "/renamed_website_images/school-gallery-032.jpeg",
    "/renamed_website_images/school-gallery-033.jpeg",
    "/renamed_website_images/school-gallery-034.jpeg",
    "/renamed_website_images/school-gallery-035.jpeg",
    "/renamed_website_images/school-gallery-036.jpeg",
    "/renamed_website_images/school-gallery-037.jpeg",
    "/renamed_website_images/school-gallery-038.jpeg",
    "/renamed_website_images/school-gallery-039.jpeg",
    "/renamed_website_images/school-gallery-040.jpeg",
    "/renamed_website_images/school-gallery-041.jpeg",
    "/renamed_website_images/school-gallery-042.jpeg",
    "/renamed_website_images/school-gallery-043.jpeg",
    "/renamed_website_images/school-gallery-044.jpeg",
    "/renamed_website_images/school-gallery-045.jpeg",
    "/renamed_website_images/school-gallery-046.jpeg",
    "/renamed_website_images/school-gallery-047.jpeg",
    "/renamed_website_images/school-gallery-048.jpeg",
    "/renamed_website_images/school-gallery-049.jpeg",
    "/renamed_website_images/school-gallery-050.jpeg",
    "/renamed_website_images/school-gallery-051.jpeg",
    "/renamed_website_images/school-gallery-052.jpeg",
    "/renamed_website_images/school-gallery-053.jpeg",
    "/renamed_website_images/school-gallery-054.jpeg",
    "/renamed_website_images/school-gallery-055.jpeg",
    "/renamed_website_images/school-gallery-056.jpeg",
    "/renamed_website_images/school-gallery-057.jpeg",
    "/renamed_website_images/school-gallery-058.jpeg",
    "/renamed_website_images/school-gallery-059.jpeg",
    "/renamed_website_images/school-gallery-060.jpeg",
    "/renamed_website_images/school-gallery-061.jpeg",
    "/renamed_website_images/school-gallery-062.jpeg",
    "/renamed_website_images/school-gallery-063.jpeg",
    "/renamed_website_images/school-gallery-064.jpeg",
    "/renamed_website_images/school-gallery-065.jpeg",
    "/renamed_website_images/school-gallery-066.jpeg",
    "/renamed_website_images/parade-training.jpg",
    "/renamed_website_images/infrastructure-section-screenshot.jpg",
    "/renamed_website_images/infrastructure-section-mobile.jpg",
    "/renamed_website_images/campus-palm-trees.jpg",
    "/renamed_website_images/smart-classroom.jpg",
    "/renamed_website_images/library-reading-1.jpg",
    "/renamed_website_images/music-guitar-class-1.jpg",
    "/renamed_website_images/sports-activities-001.jpg",
  ],
  Laboratries: [
    "/renamed_website_images/smart-classroom-session-2.jpg",
    "/renamed_website_images/smart-classroom-session-3.jpg",
    "/renamed_website_images/smart-classes-mobile.jpg",
    "/renamed_website_images/library-reading-2.jpg",
    "/renamed_website_images/library-reading-3.jpg",
    "/renamed_website_images/physics-lab-1.jpg",
    "/renamed_website_images/physics-lab-2.jpg",
    "/renamed_website_images/physics-lab-3.jpg",
    "/renamed_website_images/physics-lab-4.jpg",
    "/renamed_website_images/laboratory-gallery-01.jpg",
    "/renamed_website_images/laboratory-gallery-02.jpg",
    "/renamed_website_images/laboratory-gallery-03.jpg",
    "/renamed_website_images/laboratory-gallery-04.jpg",
    "/renamed_website_images/laboratory-gallery-05.jpg",
    "/renamed_website_images/laboratory-gallery-06.jpg",
    "/renamed_website_images/laboratory-gallery-07.jpg",
    "/renamed_website_images/laboratory-gallery-08.jpg",
    "/renamed_website_images/laboratory-gallery-09.jpg",
    "/renamed_website_images/laboratory-gallery-10.jpg",
    "/renamed_website_images/laboratory-gallery-11.jpg",
    "/renamed_website_images/laboratory-gallery-12.jpg",
  ],
  Campus: [
    "/renamed_website_images/campus-palm-trees.jpg",
    "/renamed_website_images/infrastructure-lobby-2.jpg",
    "/renamed_website_images/hostel-room.jpg",
    "/renamed_website_images/infrastructure-section-mobile.jpg",
    "/renamed_website_images/infrastructure-section-screenshot.jpg",
    "/renamed_website_images/school-library-mobile.jpg",
    "/renamed_website_images/library-reading-1.jpg",
    "/renamed_website_images/smart-classroom.jpg",
    "/renamed_website_images/smart-classroom-session-2.jpg",
    "/renamed_website_images/smart-classroom-session-3.jpg",
    "/renamed_website_images/parade-training.jpg",
    "/renamed_website_images/sports-activities-001.jpg",
    "/renamed_website_images/music-guitar-class-2.jpg",
    "/renamed_website_images/school-transport-bus-1.jpg",
    "/renamed_website_images/school-transport-bus-2.jpg",
    "/renamed_website_images/music-drums-class.jpg",
  ],
  Events: [
    "/renamed_website_images/parade-training.jpg",
    "/renamed_website_images/sports-activities-001.jpg",
    "/renamed_website_images/music-drums-class.jpg",
    "/renamed_website_images/music-drums-class-2.jpg",
    "/renamed_website_images/smart-classroom.jpg",
    "/renamed_website_images/library-reading-1.jpg",
    "/renamed_website_images/campus-palm-trees.jpg",
  ],
  "Sports Activities": [
    "/renamed_website_images/sports-activities-001.jpg",
    "/renamed_website_images/sports-activities-kabaddi-2.jpg",
    "/renamed_website_images/sports-activities-kabaddi-3.jpg",
    "/renamed_website_images/sports-activities-kabaddi-4.jpg",
    "/renamed_website_images/parade-training.jpg",
    "/renamed_website_images/campus-palm-trees.jpg",
    "/renamed_website_images/smart-classroom.jpg",
    "/renamed_website_images/library-reading-2.jpg",
    "/renamed_website_images/music-guitar-class-3.jpg",
    "/renamed_website_images/music-drums-class.jpg",
    "/renamed_website_images/music-drums-class-2.jpg",
    "/renamed_website_images/infrastructure-section-mobile.jpg",
    "/renamed_website_images/infrastructure-section-screenshot.jpg",
    "/renamed_website_images/hostel-room.jpg",
    "/renamed_website_images/infrastructure-lobby-2.jpg",
    "/renamed_website_images/school-transport-bus-1.jpg",
    "/renamed_website_images/school-transport-bus-2.jpg",
    "/renamed_website_images/smart-classroom-session-2.jpg",
    "/renamed_website_images/smart-classroom-session-3.jpg",
    "/renamed_website_images/school-library-mobile.jpg",
    "/renamed_website_images/sports-activities-gallery-01.jpg",
    "/renamed_website_images/sports-activities-gallery-02.jpg",
    "/renamed_website_images/sports-activities-gallery-03.jpg",
    "/renamed_website_images/sports-activities-gallery-04.jpg",
    "/renamed_website_images/sports-activities-gallery-05.jpg",
    "/renamed_website_images/sports-activities-gallery-06.jpg",
    "/renamed_website_images/sports-activities-gallery-07.jpg",
    "/renamed_website_images/sports-activities-gallery-08.jpg",
    "/renamed_website_images/sports-activities-gallery-09.jpg",
  ],
  Trips: [
    "/renamed_website_images/school-transport-bus-1.jpg",
    "/renamed_website_images/school-transport-bus-2.jpg",
    "/renamed_website_images/parade-training.jpg",
    "/renamed_website_images/hostel-room.jpg",
    "/renamed_website_images/campus-palm-trees.jpg",
    "/renamed_website_images/infrastructure-lobby-2.jpg",
    "/renamed_website_images/infrastructure-section-screenshot.jpg",
    "/renamed_website_images/smart-classes-mobile.jpg",
    "/renamed_website_images/library-reading-1.jpg",
    "/renamed_website_images/trip-gallery-01.jpg",
    "/renamed_website_images/trip-gallery-02.jpg",
    "/renamed_website_images/trip-gallery-03.jpg",
    "/renamed_website_images/trip-gallery-04.jpg",
    "/renamed_website_images/trip-gallery-05.jpg",
  ],
  Videos: [
    "/renamed_website_images/gallery-video-14.mp4",
    "/renamed_website_images/gallery-video-15.mp4",
    "/renamed_website_images/gallery-video-16.mp4",
    "/renamed_website_images/gallery-video-17.mp4",
    "/renamed_website_images/gallery-video-18.mp4",
    "/renamed_website_images/gallery-video-01.mp4",
    "/renamed_website_images/gallery-video-02.mp4",
    "/renamed_website_images/gallery-video-03.mp4",
    "/renamed_website_images/gallery-video-04.mp4",
    "/renamed_website_images/gallery-video-05.mp4",
    "/renamed_website_images/gallery-video-06.mp4",
    "/renamed_website_images/gallery-video-07.mp4",
    "/renamed_website_images/gallery-video-08.mp4",
    "/renamed_website_images/gallery-video-09.mp4",
    "/renamed_website_images/gallery-video-10.mp4",
    "/renamed_website_images/gallery-video-11.mp4",
    "/renamed_website_images/gallery-video-12.mp4",
    "/renamed_website_images/gallery-video-13.mp4",
  ],
};

const sectionAccents = {
  "Latest Highlights": "#f4c842",
  Events: "#f4c842",
  Campus: "#3b82f6",
  Laboratries: "#22c55e",
  "Sports Activities": "#06b6d4",
  Trips: "#8b5cf6",
  Videos: "#f97316",
};

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const scrollRefs = useRef({});
  const [scrollStates, setScrollStates] = useState({});

  const checkScroll = () => {
    const newStates = {};
    for (const key in scrollRefs.current) {
      const el = scrollRefs.current[key];
      if (el) {
        newStates[key] = {
          canScrollLeft: el.scrollLeft > 5,
          canScrollRight: el.scrollLeft + el.clientWidth < el.scrollWidth - 5,
        };
      }
    }
    setScrollStates(newStates);
  };

  useEffect(() => {
    setTimeout(checkScroll, 100);
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  const scroll = (key, direction) => {
    const el = scrollRefs.current[key];
    if (el) {
      el.scrollBy({
        left: direction === "right" ? 320 : -320,
        behavior: "smooth",
      });
      setTimeout(checkScroll, 350);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="relative min-h-screen pt-36 md:pt-40 pb-20 px-6 md:px-16 overflow-hidden"
    >
      {/* Ambient */}
      <div
        className="absolute top-0 left-0 w-96 h-96 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(244,200,66,0.05) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="pt-14 pb-12">
          <span className="section-badge mb-5 inline-flex">
            Memories & Moments
          </span>
          <h1
            className="uppercase tracking-wide"
            style={{
              fontFamily: "Orbitron, sans-serif",
              fontWeight: 900,
              fontSize: "clamp(2rem, 5vw, 3.5rem)",
              color: "#f0f5ff",
            }}
          >
            Gallery
          </h1>
          <div className="cosmic-divider w-40 mt-4" />
        </div>

        {/* Sections */}
        {Object.entries(imageSections).map(([sectionTitle, images], index) => {
          const accent = sectionAccents[sectionTitle] || "#f4c842";
          return (
            <div key={index} className="mb-16">
              {/* Section header */}
              <div className="flex items-center gap-4 mb-6">
                <div
                  className="w-1.5 h-7 rounded-full flex-shrink-0"
                  style={{
                    background: accent,
                    boxShadow: `0 0 10px ${accent}88`,
                  }}
                />
                <h2
                  className="font-black uppercase tracking-wide"
                  style={{
                    fontFamily: "Cinzel, serif",
                    fontSize: "clamp(1rem, 2vw, 1.4rem)",
                    color: "#f0f5ff",
                    letterSpacing: "0.08em",
                  }}
                >
                  {sectionTitle}
                </h2>
              </div>

              {/* Scroll row */}
              <div className="relative">
                {/* Left arrow */}
                <button
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{
                    background: scrollStates[sectionTitle]?.canScrollLeft
                      ? "rgba(2,8,16,0.85)"
                      : "rgba(2,8,16,0.4)",
                    border: `1px solid ${scrollStates[sectionTitle]?.canScrollLeft ? accent + "44" : "rgba(255,255,255,0.1)"}`,
                    color: scrollStates[sectionTitle]?.canScrollLeft
                      ? accent
                      : "rgba(255,255,255,0.25)",
                    backdropFilter: "blur(8px)",
                    cursor: scrollStates[sectionTitle]?.canScrollLeft
                      ? "pointer"
                      : "default",
                  }}
                  onClick={() => scroll(sectionTitle, "left")}
                >
                  <IoIosArrowBack size={18} />
                </button>

                {/* Scrollable row */}
                <div
                  ref={(el) => (scrollRefs.current[sectionTitle] = el)}
                  className="flex gap-3 overflow-x-auto scroll-smooth no-scrollbar px-2 py-2"
                  onScroll={checkScroll}
                >
                  {images.map((src, i) => {
                    const isVideo = src.endsWith(".mp4");
                    return isVideo ? (
                      <video
                        key={i}
                        src={src}
                        className="flex-shrink-0 rounded-xl object-cover"
                        style={{
                          width: "260px",
                          height: "175px",
                          border: `1px solid rgba(255,255,255,0.08)`,
                        }}
                        controls
                      />
                    ) : (
                      <img
                        key={i}
                        src={src}
                        alt={`${sectionTitle} ${i + 1}`}
                        className="flex-shrink-0 rounded-xl object-cover cursor-pointer transition-all duration-300 hover:scale-[1.02]"
                        style={{
                          width: "260px",
                          height: "175px",
                          border: `1px solid rgba(255,255,255,0.08)`,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                        }}
                        onClick={() => setSelectedImage(src)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = accent + "55";
                          e.currentTarget.style.boxShadow = `0 0 20px ${accent}22, 0 8px 30px rgba(0,0,0,0.4)`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor =
                            "rgba(255,255,255,0.08)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 20px rgba(0,0,0,0.3)";
                        }}
                      />
                    );
                  })}
                </div>

                {/* Right arrow */}
                <button
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{
                    background: scrollStates[sectionTitle]?.canScrollRight
                      ? "rgba(2,8,16,0.85)"
                      : "rgba(2,8,16,0.4)",
                    border: `1px solid ${scrollStates[sectionTitle]?.canScrollRight ? accent + "44" : "rgba(255,255,255,0.1)"}`,
                    color: scrollStates[sectionTitle]?.canScrollRight
                      ? accent
                      : "rgba(255,255,255,0.25)",
                    backdropFilter: "blur(8px)",
                    cursor: scrollStates[sectionTitle]?.canScrollRight
                      ? "pointer"
                      : "default",
                  }}
                  onClick={() => scroll(sectionTitle, "right")}
                >
                  <IoIosArrowForward size={18} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Lightbox modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{
            background: "rgba(2,8,16,0.92)",
            backdropFilter: "blur(12px)",
          }}
          onClick={() => setSelectedImage(null)}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="relative max-w-[90vw] max-h-[85vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              className="absolute -top-4 -right-4 w-9 h-9 rounded-full flex items-center justify-center z-10 transition-all duration-200"
              style={{
                background: "rgba(244,200,66,0.15)",
                border: "1px solid rgba(244,200,66,0.4)",
                color: "#f4c842",
              }}
              onClick={() => setSelectedImage(null)}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(239,68,68,0.2)";
                e.currentTarget.style.borderColor = "rgba(239,68,68,0.6)";
                e.currentTarget.style.color = "#ef4444";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(244,200,66,0.15)";
                e.currentTarget.style.borderColor = "rgba(244,200,66,0.4)";
                e.currentTarget.style.color = "#f4c842";
              }}
            >
              <IoIosClose size={22} />
            </button>

            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-full max-h-[80vh] object-contain rounded-xl"
              style={{
                border: "1px solid rgba(244,200,66,0.15)",
                boxShadow:
                  "0 0 60px rgba(244,200,66,0.1), 0 20px 60px rgba(0,0,0,0.7)",
              }}
            />
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default Gallery;
